/*eslint-disable no-restricted-globals*/
const yrSections = document.querySelectorAll('[data-yr-section]');
const yrLegends = document.querySelectorAll('[data-yr-legend]');

const scrollOffset = 50;

let t = null;

[...yrLegends].forEach((yrLegend) => {
    yrLegend.addEventListener('click', (event) => {
        event.preventDefault();

        const sectionSlug = event.currentTarget.dataset.yrLegend;
        const sectionDiv = document.querySelector(`[data-yr-section="${sectionSlug}"]`);

        if (sectionDiv) {
            sectionDiv.scrollIntoView({ behavior: 'smooth' });
        }
    });
});

const highlightLegend = () => {
    const { pageYOffset } = window;
    const { documentElement } = document;
    const { offsetHeight } = documentElement;
    const offset = documentElement.scrollTop + window.innerHeight;

    [...yrSections].forEach((yrSection) => {
        const sectionTop = yrSection.getBoundingClientRect().top;
        const sectionSlug = yrSection.dataset.yrSection;

        if (offset >= offsetHeight) {
            const allYRLegends = document.querySelectorAll('[data-yr-legend]');
            const lastYRLegend = allYRLegends[allYRLegends.length - 1];

            [...yrLegends].forEach((yrLegend) => {
                yrLegend.classList.remove('is-active');
            });

            lastYRLegend.classList.add('is-active');

            clearTimeout(t);

            t = setTimeout(() => {
                history.replaceState(null, null, `#${lastYRLegend.dataset.yrLegend}`);
            }, 200);
        } else if (((sectionTop + pageYOffset) - scrollOffset) <= pageYOffset) {
            const yrLegendBySlug = document.querySelector(`[data-yr-legend="${sectionSlug}"]`);

            [...yrLegends].forEach((yrLegend) => {
                yrLegend.classList.remove('is-active');
            });

            yrLegendBySlug.classList.add('is-active');

            clearTimeout(t);

            t = setTimeout(() => {
                history.replaceState(null, null, `#${yrLegendBySlug.dataset.yrLegend}`);
            }, 200);
        }
    });
};

window.addEventListener('scroll', highlightLegend);
highlightLegend();
